export default {
  namespaced: true,
  name: 'SLSClienteStore',
  state: {
    cachedInfoPedidos: {},
    clientesCache: {},
    clientes: [],
    selectedCliente: null,
    loading: false,
    filters: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      clienteid: null,
      clienteDocumento: null,
      clienterazaosocial: null,
    },
  },
  mutations: {
    SET_CACHED_INFO_PEDIDO(state, { clienteId, data }) {
      state.cachedInfoPedidos = {
        ...state.cachedInfoPedidos,
        [clienteId]: data,
      };
    },
    SET_CLIENTES_CACHE(state, { key, data }) {
      state.clientesCache = { ...state.clientesCache, [key]: data };
    },
    SET_CLIENTES(state, payload) {
      state.clientes = payload;
    },
    CACHE_INFO_PEDIDO(state, { clienteId, data }) {
      if (!state.cachedInfoPedidos) {
        state.cachedInfoPedidos = {};
      }
      state.cachedInfoPedidos[clienteId] = data;
    },
    SET_FILTERS_CLIENTE_ID(state, payload) {
      state.filters.clienteid = payload;
    },
    SET_FILTERS_RAZAO_SOCIAL(state, payload) {
      state.filters.clienterazaosocial = payload;
    },
    SET_FILTERS_CLIENTE_DOCUMENTO(state, payload) {
      state.filters.clienteDocumento = payload;
    },
    SET_FILTERS_CLIENTE_CIDADE(state, payload) {
      state.filters.clienteCidade = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_SELECTED_CLIENTE(state, payload) {
      state.selectedCliente = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = { ...state.filters, ...payload };
    },
  },
  getters: {
    clientes: (state) => state.clientes,
    selectedCLIENTE: (state) => state.selectedCliente,
    loading: (state) => state.loading,
    filters: (state) => state.filters,
    clientesCache: (state) => state.clientesCache,
    getCachedInfoPedido: (state) => (clienteId) => state.cachedInfoPedidos[clienteId] || null,
  },
};
